import { useAppSelector } from '../hooks/useAppSelector';
import { ApplicationSetting } from '../data/models/application-setting.model';
import * as referenceSlice from '../data/reference.slice';
import * as userSlice from '../data/user.slice';

const DRIVERS_LICENSE_BC = 'ISDLREQUIRED';

export const useRequireDriversLicense = (): boolean => {
  const appSettings = useAppSelector(referenceSlice.selectApplicationSettings);
  const userInfo = useAppSelector(userSlice.selectUserInfo);
  const dlRequired = appSettings.find(
    (s) => s.applicationSettingBC === DRIVERS_LICENSE_BC,
  );
  const setting = userInfo.applicationGlobalSetting.find(
    (s: ApplicationSetting) =>
      s.applicationSettingID === dlRequired?.applicationSettingID,
  );
  if (setting) {
    return setting.applicationSettingValue === '1';
  }
  return false;
};
